<template>
  <section class="policy-tab">
    <aside>
      <h2>Policy Periods</h2>
      <div
        class="policy-list">
        <div
          class="policy-item active"
        >
          <span class="bold">{{ form.type_language }}</span>
          <span>{{ form.policy_period }}</span>
        </div>
      </div>
    </aside>
    <section class="information-container">

      <div
        v-if="showAdjustPolicyBtn"
        class="text-right mg-b-15">
        <v-button
          type="primary"
          plain
          @click="onAdjustPolicy">Adjust Policy
        </v-button>
      </div>
      <div
        v-if="formData.adjust_quote_order_id"
        class="status-bar status-bar-payment flex-sb">
        <div class="left">
          <span>Payment Pending</span>
          <span>There’s a payment pending to adjust this policy.</span>
        </div>
        <div class="right">
          <v-button @click="routerToQuote(formData.adjust_quote_order_id)">View Quote</v-button>
        </div>
      </div>
      <div
        v-if="formData.adjust_void_order_id"
        class="status-bar status-bar-void flex-sb">
        <div class="left">
          <span>Void Quote</span>
          <span> An adjustment quote was voided along with this policy.</span>
        </div>
        <div class="right">
          <v-button @click="routerToQuote(formData.adjust_void_order_id)">View Quote</v-button>
        </div>
      </div>
      <template v-if="classId!=93">
        <div class="box">
          <div class="table">
            <div
              v-if="isChubb"
              class="tr">
              <span>Period</span>
              <span :class="{'green-tip':handleCompare('period_date')}">{{ form.period_date  }}</span>
            </div>
            <div class="tr">
              <span>Title</span>
              <span  :class="{'green-tip':handleCompare('isrd_title_language')}">{{ form.isrd_title_language}}</span>
            </div>
            <div class="tr">
              <span>Last Name</span>
              <span :class="{'green-tip':handleCompare('isrd_lst_nm')}">{{ form.isrd_lst_nm }}</span>
            </div>
            <div class="tr">
              <span>First Name</span>
              <span
                :class="{'green-tip':handleCompare('isrd_fst_nm')}">{{ form.isrd_fst_nm}}</span>
            </div>
            <div class="tr">
              <span>Date of Birth</span>
              <span :class="{'green-tip':handleCompare('isrd_dob')}">{{ form.isrd_dob  }}</span>
            </div>
            <div class="tr">
              <span>Mobile Number</span>
              <span :class="{'green-tip':handleCompare('mobile_no')}">{{ form.mobile_no  }}</span>
            </div>
            <template v-if="isChubb">
              <div class="tr">
                <span>HKID Number</span>
                <span :class="{'green-tip':handleCompare('id_no')}">{{ form.id_no  }}</span>
              </div>
              <div class="tr">
                <span>Email</span>
                <span :class="{'green-tip':handleCompare('email')}">{{ form.email  }}</span>
              </div>
            </template>
            <template v-if="!isChubb">
              <div class="tr">
                <span>Occupation</span>
                <span :class="{'green-tip':handleCompare('occ')}">{{ form.occ  }}</span>
              </div>
              <div class="tr">
                <span>District</span>
                <span :class="{'green-tip':handleCompare('addr_district_language')}">{{ form.addr_district_language  }}</span>
              </div>
              <div class="tr">
                <span>Area</span>
                <span :class="{'green-tip':handleCompare('addr_area_language')}">{{ form.addr_area_language  }}</span>
              </div>
              <div class="tr">
                <span>Region</span>
                <span :class="{'green-tip':handleCompare('addr_region_language')}">{{ form.addr_region_language  }}</span>
              </div>
            </template>
          </div>
        </div>
        <div
          v-if="!isChubb"
          class="box">
          <h3>Coverage</h3>
          <template v-if="productId == 91">
            <div
              v-for="(inItem, index) in form.coverage"
              :key="index"
              class="table">
              <h4>{{inItem.title}}</h4>
              <div class="tr">
                <span>Content</span>
                <span>{{inItem.content}}</span>
              </div>
              <div class="tr">
                <span>{{inItem.premium_title}}</span>
                <span>{{inItem.premium_str}}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="table">
              <div class="tr th">
                <span>Item</span>
                <span>premium</span>
              </div>
              <template v-if="form.coverage">
                <div
                  v-for="(inItem, index) in form.coverage.items"
                  :key="index + inItem.premium"
                  class="tr">
                  <span>{{ inItem.item }}</span>
                  <span>{{ inItem.premium }}</span>
                </div>
              </template>
            </div>
          </template>
        </div>
        <div
          v-else
          class="box">
          <h3>Opt out</h3>
          <template>
            <div class="table">
              <div class="tr th">
                <span>Item</span>
                <span>Value</span>
              </div>
              <template>
                <div
                  v-for="(item,index) in infectious_marketing_data"
                  :key="'opt_'+index"
                  class="tr">
                  <span>{{item.name}}</span>
                  <span>{{getOptionName('yesNoOptions',use_data.includes(item.id)?0:1)}}</span>
                </div>
              </template>
            </div>
          </template>
        </div>
      </template>
      <div
        v-else
        class="box mobile-content">
        <div class="table">
          <div class="th">Policy Details</div>
          <div
            v-if="form.pcy_no"
            class="tr">
            <span>Policy No.</span>
            <span >{{ form.pcy_no}}</span>
          </div>
          <div
            v-if="form.endorse_no"
            class="tr">
            <span>Endorsement No.</span>
            <span >{{ form.endorse_no}}</span>
          </div>
          <div class="tr">
            <span>Insured Period</span>
            <span >{{ form.period_date||'-'}}</span>
          </div>
          <div class="tr">
            <span>Title</span>
            <span>{{ form.isrd_title_language }}</span>
          </div>
          <div class="tr">
            <span>Last Name</span>
            <span>{{ form.isrd_lst_nm }}</span>
          </div>
          <div class="tr">
            <span>First Name</span>
            <span>{{ form.isrd_fst_nm}}</span>
          </div>
          <div class="tr">
            <span>Date of Birth</span>
            <span>{{ formData.isrd_dob_date }}</span>
          </div>
          <div class="tr">
            <span>Mobile Number</span>
            <span >{{ form.mobile_no  }}</span>
          </div>
          <div class="tr">
            <span>Email</span>
            <span >{{ form.email  }}</span>
          </div>
          <div class="tr">
            <span>Brand</span>
            <span >{{ form.mobile_brand  }}</span>
          </div>
          <div class="tr">
            <span>Model</span>
            <span>{{ form.mobile_model  }}</span>
          </div>
          <div class="tr">
            <span>Phone Details & IMEI</span>
            <span>
              <p>{{ form.mobile_imei_1||'--'  }}</p>
              <p>{{ form.mobile_imei_2  }}</p>
              <p>{{ form.mobile_imei_3  }}</p>
              <p>{{ form.mobile_imei_4  }}</p>
              <p>{{ form.mobile_imei_5  }}</p>
            </span>
          </div>
          <div class="tr">
            <span>Purchase Date</span>
            <span>{{ form.mobile_buy_dt  }}</span>
          </div>
          <div class="tr" >
            <span>Screen Image</span>
            <span>
              <v-upload
                v-if="formData.mobile_imei"
                :card="true"
                :disabled="true"
                :fileData="form.mobile_imei"
              />
            </span>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
import MixinFormat from '@/mixins/format'
import MixinOptions from '@/mixins/options'

export default {
  name: 'PolicyTab',
  mixins: [MixinFormat, MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    activeTab: {
      type: [String],
      default: ''
    },
    oldFormDataLock: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      formData: {
        code_disc_prm: '',
        code_disc_pct: ''
      },
      activeItem: 0,
      activeInItem: 0,
      formDataLock: 0,
      lock:0,
      adjustPremium:[],
      preformData:{}
    }
  },
  computed: {
    infectious_marketing_data(){
      let {infectious_marketing_data} = this.globalOptions||{}
      return infectious_marketing_data
    },
    marketing_data(){
      let {marketing_data} = this.form||{}
      return marketing_data||{}
    },
    use_data(){
      let {use_data} = this.marketing_data||{}
      return use_data||[]
    },
    isChubb(){
      let {product_id} =this.$route.query||{}
      return product_id == 94||product_id==95
    },
    sidebarPremium() {
      let {quote_coverage_list={},type} =this.formData||{}
      if(!quote_coverage_list) {
        return []
      }
      let { premium=[]} =quote_coverage_list||{}
      return type==50?this.adjustPremium:premium||[]
    },
    showAmount(){
      let arr = this.sidebarPremium||[]
      let obj = arr.find(item=>item.name == 'paid')||{}
      return obj.premium||''
    },
    isChange(){
      let {type} = this.formData
      let pre = this.preformData||{}
      if(type!=50) return false
      let {quote_coverage_list={}} =pre||{}
      if(!quote_coverage_list) {
        return false
      }
      let { premium=[]} =quote_coverage_list||{}
      let prePremium = premium.find(item=>item.name == 'paid')||{}
      return this.showAmount != prePremium.premium
    },
    extra_content_premium(){
      let {extra_benefits_content={}} = this.formData||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr
    },
    extra_content_pcy(){
      let {extra_content_list={}} = this.formData||{}
      let arr =[]
      if(extra_content_list){
        arr = Object.entries(extra_content_list).map(item=>item[1])
      }
      return arr
    },
    classId() {
      return this.form.class_id || 14
    },
    isDisea(){
      return [94,95].includes(this.classId)
    },
    localAllOptions() {
      if (this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`] || { mortgagor: [] }
      }
    },
    mortgagorOption() {
      // 拿status 為1的數據
      let { mortgagor=[] } = this.localAllOptions
      if(mortgagor.length) {
        mortgagor = mortgagor.filter(e=>e.status)
      }
      return mortgagor
    },
    isMortgagorOther(){
      let {mortgagor}=this.form
      let list = this.mortgagorOption.filter(item=>{
        return item.id==mortgagor
      })
      return list.length>0&&list[0].is_other==1?true:false
    },
    productId() {
      return this.$route.query.product_id || 90
    },
    currentOrderId() {
      return this.formData.id
    },
    isEndorse(){
      return [30,40].includes(this.formData.type)
    },
    // 最新單
    newestOrderIdList() {
      if (!this.recordList) return []
      const list = this.recordList.reduce((result, item) => {
        const {period_record = []} = item
        if (period_record && period_record.length > 0) {
          const len = period_record.length
          // 還要判斷是否為 cancel 單， so 遍歷吧
          let flagOrderId = -1
          for (let i = 0; i < len; i++) {
            const {type, order_id} = period_record[i]
            if (type != 40) {
              flagOrderId = order_id
              break
            }
          }
          if (flagOrderId === -1) {
            result.push(item.order_id)
          } else {
            result.push(flagOrderId)
          }
        } else {
          result.push(item.order_id)
        }
        return result
      }, [])
      return list
    },
    showAdjustPolicyBtn() {
      const {stts, adjust_policy_enable, type,adjust_button} = this.formData
      const orderType = Number(type)
      let {product_id} = this.$route.query||{}
      if(product_id==93&&adjust_button==1){
        return true
      }
      // 定单(新单:10;续保:20; 调整单:50)状态为:410才会有 adjust policy 按钮存在
      if ([301, 310, 401, 410].includes(stts) && [10, 20, 50].includes(orderType)) {
        return true
      }
      return false
    },
    disabledAdjustPolicyBtn() {
      // if(this.newestOrderId != this.formData.id) {
      //   return true
      // }

      if (!this.newestOrderIdList.includes(this.formData.id)) {
        return true
      }
      if (this.formData.adjust_quote_order_id) {
        return true
      }
      if (this.formData.adjust_policy_enable == 0) {
        return true
      }
      if (this.formData.stts == 310) {
        return true
      }
      return false
    },
    showEndorsementPremium() {
      const {type} = this.formData
      return [30, 40, 50].includes(type)
    },
    allBenefitsList() {
      if (this.classId == 14) return []
      return this[`allOptions${this.classId}`].benefits || []
    },
    recordList() {
      // 可能要改一下
      if (!this.form.record) return []
      return this.form.record.reduce((result, item) => {
        result.push({
          ...item,
          open: false
        })
        return result
      }, [])
    },
    // excessList(){
    //   let {quote_coverage_list} = this.formData||{}
    //   let {excess} = quote_coverage_list||{}
    //   let {items} = excess||{}
    //   if(items){
    //     return items[0].sub_items
    //   }
    //   return  []
    // },
    coverageList(){
      let {quote_coverage_list} = this.formData||{}
      let {coverage={}} = quote_coverage_list||{}
      return  coverage
    },
    extraBenefitSelect(){
      let {extra_benefits_content={}} = this.formData||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr||[]
    },
    option_benefits(){
      let {quote_coverage_list={}} = this.formData||{}
      let {more_benefit={}} = quote_coverage_list||{}
      let {sub_items={}} = more_benefit||{}
      let arr =[]
      if(sub_items){
        arr = Object.entries(sub_items).map(item=>item[1])
      }
      return arr
    },
    specialData(){
      let {quote_coverage_list} = this.formData||{}
      let {special_clause={}} = quote_coverage_list||{}
      return  special_clause||{}
    },
    specialList(){
      let { items=[]} = this.specialData||{}
      return items||[]
    },
    compareList(){
      let {type} = this.formData||{}
      let nowData = this.formData||{}
      let pre = this.preformData||{}
      if(type!=50)return []
      let arr =  Object.keys(nowData).reduce((result,key)=>{
        if(nowData[key]!=pre[key]){
          result.push(key)
        }
        return result
      },[])
      return arr||[]
    }
  },
  watch: {
    currentOrderId: {
      immediate: true,
      handler(id) {
        this.$emit('getCurrentOrderId', id)
      }
    },
    form: {
      immediate: true,
      handler(val, oldVal) {
        this.formData = JSON.parse(JSON.stringify(val))
        // 让子组件获取新的值
        this.formDataLock += 1
        this.order_id = this.formData.id

      }
    },
    formData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && val.id) {
          this.$emit('changeCurrentFormData', val)
        }
        let {id,type} = val||{}
      }
    }
  },
  mounted() {

  },
  methods: {
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
    handTabName(data){
      this.$emit('tabName',data)
    },
    getLocalAllOptionName(target, value) {
      if(this.classId == 14) {
        return this.getAllOptionName(target, value)
      } else {
        return this[`getAllOptionName${this.classId}`](target, value)
      }
    },
    recordItemClick(index, inIndex, inItem) {
      this.activeItem = index
      this.activeInItem = inIndex
      const {pcy_id} = this.recordList[index]
      const {order_id} = inItem
    },
    onAdjustPolicy() {
      // 當前保單數據
      this.$emit('adjust', this.formData)
    },
    routerToQuote(id) {
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: id,
          product_id: this.productId
        }
      })
    },
    network() {
      return {
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-tab {
  display: flex;

  .sub-title {
    display: block;
    padding-bottom: 15px;
    color: #616266;
    font-size: 16px;
  }

  aside {
    width: 218px;
    margin-right: 15px;

    .active {
      background: #d9ecff;
    }

    .policy-list {
      color: #409eff;
      font-size: 12px;

      .bold {
        font-weight: 500;
        font-size: 14px;
      }

      .policy-item {
        padding: 8px;
        cursor: pointer;

        span {
          display: block;
        }
      }

      .policy-status-list {
        margin-top: 1px;
        text-align: right;

        .policy-status-item {
          display: inline-block;
          padding: 8px;
          cursor: pointer;

          .time {
            display: inline-block;
            padding-left: 30px;
          }
        }
      }
    }
  }

  .information-container {
    flex: 1;

    .box {
      margin-bottom: 10px;

      h2 {
        padding-bottom: 5px;
      }

      .sign_pic {
        display: flex;
        justify-content: center;
        background: white;
      }
    }
  }

  .status-bar {
    padding: 15px;
    align-items: center;
    border-radius: 4px;
    font-size: 14px;

    .left {
      span:first-child {
        display: inline-block;
        padding-right: 15px;
        font-weight: bold;
      }
    }
  }

  .status-bar-void {
    background: #C81F1D;

    .left {
      color: white;
    }
  }

  .status-bar-payment {
    background: #fef6b3;

    .left {
      color: #723c14;
    }
  }
  .table-title {
    display: inline-block;
    padding-bottom: 2px;
    padding-left: 5px;
    font-size: 12px;
    font-weight: bold;
    color: #909399;
    line-height: 15px;
  }
  .extra-title{
    font-size: 16px;
  }
  .table{
    h4{
      padding-bottom: 10px;
      font-size: 12px;
      color: #616266
    }
  }
  .mobile-content{
    .table {
      //border: 1px solid #E1E4E8;
      &.table_no_title{
        .tr:first-child{
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
          border: 1px solid #E1E4E8;
        }
      }
      .table_tr_border0{
        .tr:last-child{
          border-radius: 0!important;
        }
      }
      .th{
        padding: 16px;
        background: $gray;
        border: 1px solid #E1E4E8;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        color: $dark!important;
        font-weight: 600;
      }
      .tr {
        padding: 8px 16px;
        border: 1px solid #E1E4E8;
        border-top: 0;
        background: #fff!important;
        display: flex;
        align-items: center;

        /* Text/text-gray */

        color: #586069;
        &.tr-gray__title{
          background: $gray!important;
          span{
            color: #24292E!important;
          }
        }
        span{
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #586069;
          &:nth-child(2){
            color: #24292E!important;
          }
        }
        .fw-600{
          font-weight: 600;
        }
        .top-algin{
          align-self: baseline;
        }
        .compare {
          display: flex;
          align-items: center;
          & > span {
            flex: 1;
          }
        }
        &:nth-child(2n){
          background: #fff;
        }
        &:last-child{
          //border: 0;
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      }
    }
  }
}
</style>
